/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import { withApollo } from 'react-apollo'
import gql from 'graphql-tag'

import {
  Spinner
} from '../'

class IdentitiesWithIdentityResponsibilities extends React.Component {
  static propTypes = {
    responsibilities: PropTypes.arrayOf(
      PropTypes.arrayOf(PropTypes.string)
    ).isRequired,
    className: PropTypes.string
  }

  constructor(props) {
    super(props)

    this.state = {
      processedResponsibilities: 0,
      identitiesWithResponsibilities: null,
      error: false
    }
  }

  componentDidMount() {
    let identitiesWithResponsibilities = []
    this.props.responsibilities.forEach((r, index) => {
      let identitiesWithResponsibility = []
      this.runIdentityReponsibilitiesQuery(r[0], r[1], r[2])
      .then(({ data }) => {
        data.identityresponsibilities.edges.map((edge) => (
          identitiesWithResponsibility.push(
            edge.node.identity.firstName+' '+edge.node.identity.lastName
          )
        ))
        identitiesWithResponsibilities.push(identitiesWithResponsibility)
        this.setState((prevState) => (
          {
            processedResponsibilities: prevState.processedResponsibilities + 1
          }
        ), () => {
          if (this.state.processedResponsibilities === this.props.responsibilities.length) {
            if (this.props.responsibilities.length > 1) {
              let intersectedIdentitiesWithResponsibilities = identitiesWithResponsibilities.reduce((a,b) => [...new Set(a)].filter(x => new Set(b).has(x)))  // get elements that intersect
              this.setState({
                identitiesWithResponsibilities: intersectedIdentitiesWithResponsibilities
              })
            } else {
              let uniqueIdentitiesWithResponsibilities = [...new Set(Array.prototype.concat(...identitiesWithResponsibilities))]  // flatten one level deep and get uniques
              this.setState({
                identitiesWithResponsibilities: uniqueIdentitiesWithResponsibilities
              })
            }
          }
        })
      })
      .catch((error) => this.setState({ error: true }))
    })
  }

  runIdentityReponsibilitiesQuery = (responsibilityType, relatedModel, relatedId) => (
    this.props.client.query({
      query: gql`
        query($responsibilityType: String!, $relatedModel: String!, $relatedId: UUID) {
          identityresponsibilities(responsibilitytype_Name: $responsibilityType, relatedModel_Model: $relatedModel, relatedId: $relatedId) {
            edges {
              node {
                id
                relatedModel {
                  id
                  model
                }
                relatedId
                responsibilitytype {
                  id
                  name
                }
                identity {
                  id
                  firstName
                  lastName
                  contacts {
                    edges {
                      node {
                        id
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `,
      variables: {
        responsibilityType,
        relatedModel: relatedModel || '',
        relatedId: relatedId || ''
      }
    })
  )

  render() {
    let identities = this.state.identitiesWithResponsibilities
    if (this.state.error) {
      return (
        <span>
          ... (problem occurred loading names)
        </span>
      )
    } else if (!identities) {
      return <Spinner type="brand" size="x-small" />
    } else {
      return (
        <span className={this.props.className ? this.props.className : ''}>
          {/* display with comma's  */}
          {identities.length > 0
            ? identities.join(', ')
            : "... (nobody assigned)"
          }
        </span>
      )
    }
  }
}

export default withApollo(IdentitiesWithIdentityResponsibilities)



// WEBPACK FOOTER //
// ./src/components/identities-with-identity-responsibilities/index.js